import axios, { AxiosError } from 'axios';
import { CAMPANHA_URL, CAMPANHA_OAUTH_CLIENT_ID, CAMPANHA_OAUTH_CLIENT_SECRET } from 'domain/infra/data/env';
import { CampanhaOAuthResponse, CampanhaOAuthRequest } from '../../types/auth/campanhaOAuthResponse';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';

export class CampanhaOAuthService {
    async GetToken(): Promise<CampanhaOAuthResponse | Error> {
        try {
            const usuarioId = _UserData.Get<string>(UserDataBaseEnum.UsuarioID);

            const request: CampanhaOAuthRequest = {
                grant_type: 'client_credentials',
                client_id: CAMPANHA_OAUTH_CLIENT_ID,
                client_secret: CAMPANHA_OAUTH_CLIENT_SECRET,
                claims: {
                    UsuarioID: usuarioId,
                },
            };

            const response = await axios.post<CampanhaOAuthResponse>(
                `${CAMPANHA_URL}/oauth2/token`,
                request
            );

            return response.data;
        } catch (error) {
            const axiosError = error as AxiosError;
            const errorMessage = axiosError.response?.data
                ? (typeof axiosError.response.data === 'string'
                    ? axiosError.response.data
                    : JSON.stringify(axiosError.response.data))
                : axiosError.message || 'Erro ao obter token OAuth2 da Campanha';
            return new Error(errorMessage);
        }
    }
}
